<template>
    <div class="lang">
        <div class="info">
            <h3 class="bullet01">Часы амбулаторного приема и обслуживания</h3>
            <p class="depth">Вы можете записаться на прием к врачу по телефону или электронной почте, либо на нашем веб-сайте. Чтобы назначить прием или лечение, от вас потребуется предоставить персональные данные и подробно описать симптомы.</p>
            <div class="table mt20">
                <table>
                    <colgroup>
                        <col style="width: 25%">
                        <col style="width: auto">
                        <col style="width: 15%">
                    </colgroup>
                    <thead>
                        <tr>
                            <th scope="col" colspan="2">Более подробную информацию о записи на прием к врачу и о процедуре работы Центра Вы можете получить</th>
                            <th scope="col">Время работы Центра</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>по телефону</td>
                            <td>обратившись в Международный медицинский центр по номеру телефона (+82-2650-5897)</td>
                            <td>09:00 ~ 17:00</td>
                        </tr>
                        <tr>
                            <td>по электронной почте</td>
                            <td><a href="mailto:ewha.rus@gmail.com">ewha.rus@gmail.com</a></td>
                            <td>24 часа</td>
                        </tr>
                        <tr>
                            <td>через веб-сайт</td>
                            <td>
                                <div style="display: ruby;">
                                    Вы также можете заказать прием в режиме онлайн на веб-сайте Центра
                                    &nbsp;&nbsp;
                                    <a href="/mongol/reservation/reservation.do"
                                        class="main-button small c-main">прием</a>
                                </div>
                            </td>
                            <td>24 часа</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="info">
            <h3 class="bullet01">Изменение времени приема или отмена приема</h3>
            <p class="depth">
                Если по какой-либо причине вы не можете прибыть на амбулаторный прием, просим связаться с нами не позднее чем за один день для изменения даты или отмены приема.
            </p>
            <div class="table mt20">
                <table>
                    <colgroup>
                        <col style="width: 25%;">
                        <col>
                    </colgroup>
                    <thead>
                        <tr>
                            <th scope="col" colspan="2">Более подробную информацию о записи на прием к врачу и о процедуре работы Центра Вы можете получить</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>по телефону</td>
                            <td>International Healthcare Center (+82-2650-5897)</td>
                        </tr>
                        <tr>
                            <td>по электронной почте</td>
                            <td><a href="mailto:ewha.rus@gmail.com">ewha.rus@gmail.com</a></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>